import React from 'react';

const PersonalTable = ({ data, columns, onDelete, onEdit }) => {
  if (!data || data.length === 0) {
    return <div className="p-4 text-gray-500">No personal data available</div>;
  }

  // ✅ Format cell values with verified logic
  const formatCellValue = (key, value) => {
    if (value === null || value === undefined || value === '') {
      return '-';
    }

    if (key === 'verified') {
      const v = value.toString().toLowerCase();
      if (v === 'verified.jpg' || v === 'yes' || v === 'verified') {
        return <span className="text-green-600 font-medium">Verified</span>;
      }
      return <span className="text-red-600 font-medium">Not Verified</span>;
    }

    return value;
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white">
        <thead>
          <tr className="bg-gray-100">
            {columns.map(column => (
              <th 
                key={column}
                className="py-2 px-4 border-b border-gray-200 text-left text-sm font-semibold text-gray-700 capitalize"
              >
                {column.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ')}
              </th>
            ))}
            <th className="py-2 px-4 border-b border-gray-200 text-left text-sm font-semibold text-gray-700">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id} className="hover:bg-gray-50">
              {columns.map(column => (
                <td 
                  key={`${item.id}-${column}`}
                  className="py-2 px-4 border-b border-gray-200 text-sm text-gray-700 max-w-xs truncate"
                  title={String(item[column] || '')}
                >
                  {formatCellValue(column, item[column])}
                </td>
              ))}
              <td className="py-2 px-4 border-b border-gray-200 text-sm">
                <div className="flex gap-2">
                  <button
                    onClick={() => onEdit(item)}
                    className="px-3 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600 text-sm"
                  >
                    Verify
                  </button>
                  <button
                    // ✅ Pass both id & profile
                    onClick={() => onDelete(item.id, item.profile)}
                    className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                  >
                    Delete User
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PersonalTable;
